import SalesRegion from './SalesRegion';

export default SalesRegion;
